<template>
  <div class="full-container service">
    <apj-page-banner :options="options"></apj-page-banner>
    <div
      class="container introduce-container"
      style="padding-top: 50px; padding-bottom: 50px"
    >
      <div class="title">行业背景</div>
      <div class="pi-align-center pi-mg-bottom-28">
        <div class="item pi-mg-right-28">
          资源与环境问题是人类面临的共同挑战，能源资源利用效率成为衡量国家制造业竞争力的重要因素
        </div>
        <div class="item">
          未来五年是我国落实制造强国战略的关键时期，推进绿色发展是我国提升国际竞争力的必然途径
        </div>
      </div>
      <div class="pi-align-center">
        <div class="item pi-mg-right-28">
          我国工业总体上尚未摆脱高投入、高消耗、高排放的发展方式，资源能源消耗量大，生态环境问题比较突出，迫切需要加快构建科技含量高、资源消耗低、环境污染少的绿色制造体系
        </div>
        <div class="item">
          加快推进工业绿色发展，也是推进供给侧结构性改革、促进工业稳增长调结构的
          重要举措，有利于推进节能降耗、实现降本增效
        </div>
      </div>
    </div>
    <div
      class="container introduce-container"
      style="padding-top: 50px; padding-bottom: 50px"
    >
      <div class="title">方案概述</div>
      <div class="content">
        智慧能源数据管理平台解决方案构建一个贯穿能源计量采集、能源实时监控、能源动态分析、能源优化控制、能源结构改进的全过程能源管控平台，对工业企业的冷、热、电、风、水、废、消防、安防、环境等能源介质的运行实况监测用能异常现象、评估能源运行状态、诊断用能缺陷、挖掘节能潜力，从而对运行负荷预测，提出运行优化方案，指导企业合理用能，推进节能降耗、实现降本增效，推动企业逐步向低碳高能转型。
      </div>
    </div>
    <div class="container res-flow-1">
      <img :src="img[0]" width="70%" />
    </div>
    <div class="full-container res-flow-2">
      <div
        class="container introduce-container"
        style="padding-top: 50px; padding-bottom: 50px"
      >
        <div class="title">业务总体架构</div>
      </div>
      <img :src="img[1]"  style="max-width:1200px;width:100%"/>
    </div>
    <div class="full-container res-flow-3">
      <div
        class="container introduce-container"
        style="padding-top: 50px; padding-bottom: 50px"
      >
        <div class="title">方案功能模块</div>
      </div>
      <img :src="img[2]" style="max-width:1200px;width:100%"/>
    </div>
    <div class="full-container res-advantage pi-pd-bottom-50" style="background: #f5f5f5">
      <div
        class="container introduce-container"
        style="padding-top: 50px; padding-bottom: 50px"
      >
        <div class="title">特色功能</div>
      </div>
      <div class="res-items">
        <div class="pi-justify-center">
          <template v-for="(item, index) in advantage">
            <div class="res-item" :key="'advantage' + index" v-if="index < 3">
              <span class="res-number">{{ "0" + (index + 1) }}</span>
              <div class="res-desc">{{ item }}</div>
            </div>
          </template>
        </div>
      </div>
      <div class="res-items">
        <div class="pi-justify-center">
          <template v-for="(item, index) in advantage">
            <div class="res-item" :key="'advantage' + index" v-if="index >= 3">
              <span class="res-number">{{ "0" + (index + 1) }}</span>
              <div class="res-desc">{{ item }}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="full-container pi-pd-bottom-50">
      <div
        class="container introduce-container"
        style="padding-top: 50px; padding-bottom: 50px"
      >
        <div class="title">方案特色</div>
      </div>
      <img :src="img[3]" style="max-width:1200px;width:100%"/>
    </div>

    <div
      class="full-container res-get"
      :style="{ 'background-image': 'url(' + getImg + ')' }"
    >
      <div class="get-title">立即拥有属于您的能源管理平台</div>
      <div class="get-button">扫码获取方案</div>
      <el-image class="get-img" :src="contactQrImg"></el-image>
    </div>
    <apj-page-contact></apj-page-contact>
  </div>
</template>

<script>
import ApjPageContact from "@/components/apj-page-contact";
import ApjPageBanner from "@/components/apj-page-banner";
export default {
  name: "res",
  components: {
    ApjPageContact,
    ApjPageBanner,
  },
  data() {
    return {
      options: {
        banner: require("@/assets/images/product/bg_1.jpg"),
        title: "综合性能源数据管理平台",
        text: "",
      },
      img: [
        require("@/assets/images/product/img_0.png"),
        require("@/assets/images/product/img_1.png"),
        require("@/assets/images/product/img_2.png"),
        require("@/assets/images/product/img_3.png"),
      ],
      getImg: require("@/assets/site/contact_bg.jpg"),
      contactQrImg: require("@/assets/site/dp_qr.png"),
      advantage: [
        "在线WEB组态，无需额外安装组态工具",
        "实时监控设备运行数据，按预设规则判断是否异常",
        "提供灵活的计费计算方式，计算各种能源的消耗费用",
        "灵活的工作台配置，用户可根据需求定制工作台",
        "专业的云端服务模块，可以根据需要开通专业服务",
      ],
    };
  },
  mounted() {
    // 进入页面时，菜单是否透明，或不显示阴影，默认为false，这里是示例
    globalEvent.$emit("changeHeaderTransparent", {
      isTransparent: true,
      isNoShadow: false,
    });
    globalEvent.$emit("changeMenu", 3);
    // globalEvent.$emit('pageLoad')
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.item {
  width: 626px;
  height: 110px;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-left: 5px solid #dd191a;
  font-size: 14px;

  font-weight: 400;
  color: #222222;
  line-height: 28px;
  padding: 0 34px;
  padding-top: 18px;
}
@import "@/assets/theme.scss";

div {
  width: 100%;
}

/** page style */
.res-introduce {
  align-self: flex-start;
  max-width: 1140px;
}
.introduce-container {
  max-width: 1140px;
  padding: 80px;
}

.introduce-container-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.title {
  padding: 10px 0 30px;
  font-size: 30px;
  font-weight: bold;
}

.res-flow-1 {
  padding: 0px 0 80px;
}
.res-flow-2 {
  height: 690px;
  background-color: $color-bg-grey;
  padding: 0px 0 50px;
  img {
    background-color: $color-bg-white;
    border-radius: 10px;
    box-shadow: 2px 2px 10px #eeeeee;
    padding: 20px;
  }
}
.res-flow-3 {
  padding: 350px 0 80px;
  padding-bottom: 100px;
}
.res-items {
  display: flex;
  justify-content: center;
  padding: 0 160px;

  .res-item {
    width: 293px;
    height: 240px;
    background: #ffffff;
    border: 1px solid #dddddd;
    min-height: 220px;
    padding: 15px;
    margin: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid $color-border-grey;

    .res-number {
      width: 40px;
      padding-bottom: 10px;
      margin-bottom: 30px;
      font-size: 30px;
      word-spacing: 10px;
      font-weight: bold;
      border-bottom: 3px solid $color-border-primary;
    }
  }
  .res-item:hover {
    cursor: pointer;
    background-color: $color-bg-primary;
    .res-number {
      color: $color-text-white;
      border-bottom: 3px solid $color-border-white;
    }
    .res-desc {
      color: $color-text-white;
    }
  }
}

.res-get {
  padding-top: 80px;
  margin-top: 50px;
  height: 500px;

  .get-title {
    font-size: 42px;
    line-height: 84px;
  }
  $buttonHeight: 40px;
  .get-button {
    width: 200px;
    height: $buttonHeight;
    border-radius: $buttonHeight;
    line-height: $buttonHeight;
    background-color: $color-bg-primary;
    color: $color-text-white;
  }
  .get-img {
    margin-top: $buttonHeight;
    width: 150px;
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/resource-management/index.vue